
<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="$t('reservaSimplificada.titulo')"
  >
  <v-card>
    <v-container fluid>
      <v-layout 
        :column="$vuetify.breakpoint.xsOnly"
        :justify-space-around="!$vuetify.breakpoint.smAndDown"
      >
        <v-flex
          xs12 sm10 md5 xl4    
        >
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('general.misc.buscar')"
          />
        </v-flex>
      </v-layout>
          <v-data-table 
            :loading="waitingForLoad"
            :headers="headers"
            :items="filteredItems"
            item-key="codigo"
          >
            <template slot="items" slot-scope="props">
              <tr >
                <td class="text-xs-left tableSmallPadding">
                  {{props.item.codigo}}
                </td>
                <td class="text-xs-left tableSmallPadding">
                  {{props.item.descripcion}}
                </td>
                <td class="text-xs-left tableSmallPadding">
                  {{props.item.ventaExtendida ?  $t('reservaSimplificada.configurada'): $t('reservaSimplificada.noconfigurada')}}
                </td>
                <td class="text-xs-left tableSmallPadding">
                  {{props.item.ventaSimplificada ? $t('reservaSimplificada.configurada'): $t('reservaSimplificada.noconfigurada')}}
                </td>
                <td class="text-xs-left tableSmallPadding">
                  {{props.item.alquilerExtendido ?  $t('reservaSimplificada.configurado'): $t('reservaSimplificada.noconfigurado')}}
                </td>
                <td class="text-xs-left tableSmallPadding">
                  {{props.item.alquilerSimplificado ?  $t('reservaSimplificada.configurado'): $t('reservaSimplificada.noconfigurado')}}
                </td>
                <td class="text-xs-center">
                  <v-btn flat icon
                  @click="configuratePromo(props.item)" 
                  >
                    <v-icon color="primary" >
                      build
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
  </page-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      search: null,
      waitingForLoad: false,
      items: [],
      headers: [
        {
          text: this.$t('reservaSimplificada.codigo'),
          value: 'codigo',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.descripcion'),
          value: 'descripcion',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.ventaextendida'),
          value: 'ventaExtendido',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.ventasimplificada'),
          value: 'ventaSimplificada',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.alquilerextentido'),
          value: 'alquilerExtendido',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.alguilersimplificado'),
          value: 'alquilerSimplificado',
          align: 'left',
          class: 'tableSmallPadding',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.acciones'),
          value: 'alquilerSimplificado',
          align: 'center',
          class: 'tableSmallPadding',
          sortable: true
        }
      ]
    }
  },
  async created () {
    this.waitingForLoad = true
    await this.loadPromociones(this.usuario.id)
    this.items = this.promociones.map(x => { return {...x} })
    this.waitingForLoad = false
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario',
      promociones: 'promociones/getAll'
    }),
    filteredItems () {
      if (this.waitingForLoad) {
        return []
      }
      let auxItems = this.items
      if (this.search != null && this.search.length > 0) {
        let normalizedSearchValue = this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        auxItems = auxItems.filter(x =>
          (x.descripcion.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(normalizedSearchValue)
          )
        )
      }
      return auxItems
    },
    breadcrumbs () {
      return [
        {
          text: this.$t('pages.home'),
          exact: true,
          to: {name: 'home'}
        },
        {
          text: this.$t('pages.configuracion.configuracion'),
          exact: true,
          to: {name: 'configuracion'}
        },
        {
          text: this.$t('reservaSimplificada.breadcrumb'),
          disabled: true
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromociones: 'promociones/loadAll'
    }),
    configuratePromo (promocion) {
      this.$router.push({name: 'configuracion.general', params: {promocion}})
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/configuracion/configuracionPromo.vue